import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import {
  IDashboard,
  IFinancial,
  IGetActivity,
  IGetFinancial,
  IResponseGetActivityReport,
  IResponseGetFranchiseMKTReport,
  IResponseGetLeadReport,
  IResponseGetProjectReport,
  IResponseGetSourceReferralReport,
  IResponseGetStaffSaleReport,
  IGetTimeClockReport,
  IResponseGetTimeClockReport,
} from '~/utils/interface/report';

const reportApi = {
  getFinancial(params: IGetFinancial) {
    return axiosClient.get<IApiBaseResponse<IFinancial>>(`api/admin/reports/financial`, { params });
  },

  getDashboard() {
    return axiosClient.get<IApiBaseResponse<IDashboard>>(`api/admin/reports/dashboard`);
  },

  getActivity(params: IGetActivity) {
    return axiosClient.get<IApiBaseResponse<IResponseGetActivityReport>>(`api/admin/reports/activity`, { params });
  },

  getFranchiseMKT(params: IGetActivity) {
    return axiosClient.get<IApiBaseResponse<IResponseGetFranchiseMKTReport>>(`api/admin/reports/franchise-mkt`, {
      params,
    });
  },

  getLeadReport(params: IGetActivity) {
    return axiosClient.get<IApiBaseResponse<IResponseGetLeadReport>>(`api/admin/reports/lead-report`, { params });
  },

  getStaffSaleReport(params: IGetActivity) {
    return axiosClient.get<IApiBaseResponse<IResponseGetStaffSaleReport>>(`api/admin/reports/staff-sale`, { params });
  },

  getProjectReport(params: IGetActivity) {
    return axiosClient.get<IApiBaseResponse<IResponseGetProjectReport>>(`api/admin/reports/project`, { params });
  },

  getSaleReport(params: IGetActivity) {
    return axiosClient.get<IApiBaseResponse<IResponseGetProjectReport>>(`api/admin/reports/sale`, { params });
  },

  getClosingRateReport(params: IGetActivity) {
    return axiosClient.get<IApiBaseResponse<IResponseGetProjectReport>>(`api/admin/reports/closing-rate`, { params });
  },

  getSourceReferralReport(params: IGetActivity) {
    return axiosClient.get<IApiBaseResponse<IResponseGetSourceReferralReport>>(`api/admin/reports/source-referral`, {
      params,
    });
  },

  getTimeClockReport(params: IGetTimeClockReport) {
    return axiosClient.get<IApiBaseResponse<IResponseGetTimeClockReport>>(`api/admin/reports/time-clock`, {
      params,
    });
  },
};

export default reportApi;
